import { RoleEnum } from '__generated__/types';
import { useDealIntercompanyObjectsQuery } from 'components/Deal/IntercompanyObjects/graphql/__generated__/dealIntercompanyObjects';
import { useParams } from 'react-router-dom';

interface RouteParams {
  dealId: string;
}

interface Props {
  skip?: boolean;
}

/** Returns true if the deal is a child deal. Deal page only. */
export const useIsChildDeal = (props?: Props) => {
  const { dealId } = useParams<RouteParams>();
  const { data, ...rest } = useDealIntercompanyObjectsQuery({
    variables: { id: dealId },
    skip: !dealId || props?.skip,
  });

  const childDeal = data?.deal?.intercompanyObjects?.find((object) => object.role === RoleEnum.Prod);
  const isChildDeal = !!childDeal;

  return { isChildDeal, childDeal, ...rest };
};
